import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "是否異常",
    isNumber: true,
  },
];

export const Bar = {
  label: "各項需追蹤人數_長條圖",
  key: "Bar",
  path: "HealthAnalysisManagement/Bar",
  api: "TCS_V_EyesS01",
  render: (options) => <Diagram.HealthAnalysisManagement.Bar {...options} />,
  // isBarStack: true,
  isYMulti: true,
  rightYDomain: [200, 0],
  xKey: "type",
  barUnit: "人",
  barColumns: [
    {
      key: "aa",
      label: "需諮詢人數",
      ui: "bar",
    },
    {
      key: "bb",
      label: "已諮詢",
      ui: "bar",
    },
    {
      key: "cc",
      label: "自行追蹤",
      ui: "bar",
    },
    {
      key: "dd",
      label: "已追蹤",
      ui: "bar",
    },
  ],
  lineUnit: "%",
  lineColumns: [
    {
      key: "ee",
      label: "健檢諮詢%",
      ui: "line",
    },
  ],
  columns: [],
};
